<template>
  <div class="social-posts container-fluid py-4">
    <div class="row h-100">
      <!-- Sidebar: Configuration & Creation -->
      <div class="col-lg-4 col-xl-3 mb-4">
        <div class="config-sidebar sticky-top" style="top: 20px;">
          <!-- Agent Delegation Card -->
          <div class="glass-card p-4 mb-4">
            <h5 class="mb-4 d-flex align-items-center">
              <div class="icon-circle bg-primary-soft me-2">
                <i class="fas fa-robot"></i>
              </div>
              Delega Agente AI
            </h5>
            
            <div class="mb-3">
              <label class="form-label small fw-bold">Post a settimana</label>
              <div class="input-group input-group-sm">
                <button class="btn btn-outline-secondary" @click="agentSettings.postsPerWeek > 1 && agentSettings.postsPerWeek--">-</button>
                <input type="number" class="form-control text-center" v-model="agentSettings.postsPerWeek" min="1" max="20">
                <button class="btn btn-outline-secondary" @click="agentSettings.postsPerWeek < 20 && agentSettings.postsPerWeek++">+</button>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label small fw-bold">Tipologia Contenuto</label>
              <select class="form-select form-select-sm" v-model="agentSettings.contentType">
                <option value="promotional">Promozionale (Offerte, Piatti)</option>
                <option value="engagement">Engagement (Domande, Curiosità)</option>
                <option value="informative">Informativo (Orari, Eventi)</option>
                <option value="mixed">Misto</option>
              </select>
            </div>

            <div class="row g-2 mb-3">
              <div class="col-6">
                <label class="form-label small fw-bold">Inizio</label>
                <input type="date" class="form-control form-control-sm" v-model="agentSettings.startDate">
              </div>
              <div class="col-6">
                <label class="form-label small fw-bold">Fine</label>
                <input type="date" class="form-control form-control-sm" v-model="agentSettings.endDate">
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label small fw-bold">Info Attività / Note</label>
              <textarea class="form-control form-control-sm" v-model="agentSettings.businessInfo" rows="3" placeholder="Es. Ristorante di pesce fresco..."></textarea>
            </div>

            <div class="mb-4">
              <label class="form-label d-block small fw-bold">Opzioni AI:</label>
              <div class="form-check form-switch small">
                <input class="form-check-input" type="checkbox" id="agentGenImgAI" v-model="agentSettings.generateImageAI">
                <label class="form-check-label text-muted" for="agentGenImgAI">
                  <i class="fas fa-magic me-1"></i>Genera immagini per ogni post
                </label>
              </div>
            </div>

            <div class="mb-4">
              <label class="form-label d-block small fw-bold">Modalità Pubblicazione:</label>
              <div class="btn-group w-100" role="group">
                <input type="radio" class="btn-check" name="publishMode" id="modeAuto" value="auto" v-model="agentSettings.publishMode">
                <label class="btn btn-outline-primary btn-sm" for="modeAuto">Auto</label>
                
                <input type="radio" class="btn-check" name="publishMode" id="modeDraft" value="draft" v-model="agentSettings.publishMode">
                <label class="btn btn-outline-primary btn-sm" for="modeDraft">Bozza</label>
              </div>
            </div>

            <button class="btn btn-primary w-100 shadow-sm" @click="saveAgentSettings" :disabled="isLoading">
              <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
              <i v-else class="fas fa-magic me-2"></i>Attiva Agente
            </button>
          </div>

          <!-- Manual Post Card -->
          <div class="glass-card p-4">
            <h5 class="mb-4 d-flex align-items-center">
              <div class="icon-circle bg-secondary-soft me-2">
                <i class="fas fa-edit"></i>
              </div>
              Nuovo Post
            </h5>
            <textarea class="form-control border-0 bg-light-soft mb-2" rows="4" placeholder="Cosa vorresti pubblicare oggi?" v-model="manualContent"></textarea>
            
            <div class="form-check form-switch mb-3 small">
              <input class="form-check-input" type="checkbox" id="genImgAI" v-model="generateImageAI">
              <label class="form-check-label fw-bold text-muted" for="genImgAI">
                <i class="fas fa-magic me-1"></i>Genera immagine AI
              </label>
            </div>

            <button class="btn btn-dark w-100" @click="createManualPost" :disabled="!manualContent || isLoading">
              <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
              <i v-else class="fas fa-paper-plane me-2"></i>Crea Bozza
            </button>
          </div>
        </div>
      </div>

      <!-- Main Content: Post Feed -->
      <div class="col-lg-8 col-xl-9">
        <div class="feed-header d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
          <h4 class="mb-0 fw-bold">Storico Post & Programmazione</h4>
          
          <div class="d-flex gap-2 align-items-center">
            <div class="search-bar">
              <i class="fas fa-search"></i>
              <input type="text" class="form-control form-control-sm" placeholder="Cerca contenuto..." v-model="searchQuery">
            </div>
            
            <select class="form-select form-select-sm status-filter" v-model="statusFilter">
              <option value="ALL">Tutti gli stati</option>
              <option value="DRAFT">Bozze</option>
              <option value="SCHEDULED">Programmati</option>
              <option value="PUBLISHED">Pubblicati</option>
              <option value="FAILED">Errori</option>
            </select>

            <button class="btn btn-light btn-sm rounded-circle border shadow-sm" @click="loadPosts" title="Aggiorna">
              <i class="fas fa-sync-alt"></i>
            </button>
          </div>
        </div>

        <div v-if="Object.keys(groupedPostsByMonth).length === 0" class="empty-state text-center py-5">
          <div class="empty-illustration mb-3">
            <i class="fas fa-calendar-times fa-4x text-muted opacity-25"></i>
          </div>
          <h3>Nessun post trovato</h3>
          <p class="text-muted">Inizia a programmare i tuoi contenuti social con l'AI.</p>
        </div>

        <div v-else class="posts-timeline">
          <div v-for="(group, monthName) in groupedPostsByMonth" :key="monthName" class="month-section mb-5">
            <h5 class="month-title mb-4">
              <span>{{ monthName }}</span>
              <div class="title-line"></div>
            </h5>
            
            <div class="row g-3">
              <div v-for="post in group" :key="post._id" class="col-md-6 col-xl-4">
                <div class="post-card h-100" :class="{ 'is-published': post.status === 'PUBLISHED' }">
                  <div class="post-card-header d-flex justify-content-between mb-2">
                    <span class="badge" :class="getTypeBadgeClass(post)">
                      {{ getContentTypeLabel(post) }}
                    </span>
                    <span class="badge" :class="getStatusBadgeClass(post.status)">
                      {{ getStatusLabel(post.status) }}
                    </span>
                  </div>
                  
                  <div class="post-content mb-3">
                    {{ post.content }}
                  </div>
                  <div v-if="post.images && post.images.length > 0" class="post-images mb-3 rounded overflow-hidden">
                    <img :src="getImageUrl(post.images[0])" class="w-100 object-fit-cover" style="max-height: 200px;" alt="Post content">
                  </div>
                  
                  <div class="post-footer mt-auto pt-3 border-top">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="date-info small text-muted">
                        <div v-if="post.scheduledDate" class="text-primary-cool">
                          <i class="far fa-clock me-1"></i> {{ formatDate(post.scheduledDate) }}
                        </div>
                        <div v-else>
                          <i class="far fa-calendar-alt me-1"></i> {{ formatDate(post.createdAt) }}
                        </div>
                      </div>
                      
                      <div class="actions">
                        <button 
                          v-if="post.status === 'DRAFT'" 
                          class="btn btn-icon btn-outline-success"
                          @click="publishToFacebook(post)"
                          :disabled="publishingPostId === post._id"
                          title="Pubblica su Facebook"
                        >
                          <span v-if="publishingPostId === post._id" class="spinner-border spinner-border-sm"></span>
                          <i v-else class="fab fa-facebook-f"></i>
                        </button>
                      </div>
                    </div>
                    
                    <div v-if="post.agentError" class="error-msg mt-2 p-1 px-2 rounded small text-danger bg-danger-soft">
                      <i class="fas fa-exclamation-circle me-1"></i>{{ post.agentError }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store/store.js'

export default {
  name: 'SocialPosts',
  data() {
    return {
      store,
      userId: JSON.parse(localStorage.token_id || '{}')._id || 'test_user_id',
      manualContent: '',
      generateImageAI: false,
      searchQuery: '',
      statusFilter: 'ALL',
      isLoading: false,
      posts: [],
      publishingPostId: null,
      agentSettings: {
        postsPerWeek: 3,
        contentType: 'mixed',
        businessInfo: '',
        publishMode: 'draft',
        generateImageAI: false,
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)
      }
    }
  },
  computed: {
    groupedPostsByMonth() {
      const groups = {};
      const filtered = this.posts.filter(p => {
        // Exclude internal configuration posts
        if (p.content === 'Agent Configuration') return false;
        
        // Search filter
        const matchesSearch = !this.searchQuery || 
                             p.content?.toLowerCase().includes(this.searchQuery.toLowerCase());
        
        // Status filter
        const matchesStatus = this.statusFilter === 'ALL' || p.status === this.statusFilter;
        
        return matchesSearch && matchesStatus;
      });

      filtered.forEach(post => {
        const date = new Date(post.scheduledDate || post.createdAt);
        const monthYear = date.toLocaleString('it-IT', { month: 'long', year: 'numeric' });
        
        if (!groups[monthYear]) groups[monthYear] = [];
        groups[monthYear].push(post);
      });

      // Sort months descending
      const sortedKeys = Object.keys(groups).sort((a, b) => {
        const dateA = new Date(groups[a][0].scheduledDate || groups[a][0].createdAt);
        const dateB = new Date(groups[b][0].scheduledDate || groups[b][0].createdAt);
        return dateB - dateA;
      });

      const result = {};
      sortedKeys.forEach(key => {
        // Sort posts within month by creation date descending
        result[key] = groups[key].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      });
      
      return result;
    }
  },
  mounted() {
    this.loadPosts();
  },
  methods: {
    async loadPosts() {
      try {
        const apiBase = this.store.path || 'http://localhost:5000/login/';
        const endpoint = apiBase.endsWith('/') ? `${apiBase}social/posts` : `${apiBase}/social/posts`;
        
        const res = await this.axios.get(endpoint, {
          params: { userId: this.userId },
          headers: {
            authorization: `Bearer ${localStorage.token ? JSON.parse(localStorage.token) : ''}`
          }
        });
        
        this.posts = res.data || [];
        
        // If there's an agent config post, update local settings
        const configPost = this.posts.find(p => p.content === 'Agent Configuration');
        if (configPost && configPost.agentSettings) {
          this.agentSettings = { ...this.agentSettings, ...configPost.agentSettings };
        }
      } catch (error) {
        console.error('Error loading posts:', error);
      }
    },
    
    async saveAgentSettings() {
      this.isLoading = true;
      try {
        const apiBase = this.store.path || 'http://localhost:5000/login/'; 
        const endpoint = apiBase.endsWith('/') ? `${apiBase}social/posts` : `${apiBase}/social/posts`;

        await this.axios.post(endpoint, {
            userId: this.userId,
            content: "Agent Configuration",
            agentSettings: this.agentSettings
        }, {
            headers: {
                 authorization: `Bearer ${localStorage.token ? JSON.parse(localStorage.token) : ''}`
            }
        });

        alert('Preferenze agente salvate! L\'agente inizierà a lavorare.');
        setTimeout(() => this.loadPosts(), 2000);
      } catch (error) {
        console.error('Error saving agent settings:', error);
        alert('Errore: ' + (error.response?.data?.message || error.message));
      } finally {
        this.isLoading = false;
      }
    },
    
    async createManualPost() {
        if (!this.manualContent) return;
        try {
            const apiBase = this.store.path || 'http://localhost:5000/login/'; 
            const endpoint = apiBase.endsWith('/') ? `${apiBase}social/posts` : `${apiBase}/social/posts`;

            await this.axios.post(endpoint, {
                userId: this.userId,
                content: this.manualContent,
                generateImageAI: this.generateImageAI,
                status: 'DRAFT'
            }, {
                headers: {
                    authorization: `Bearer ${localStorage.token ? JSON.parse(localStorage.token) : ''}`
                }
            });
            
            this.manualContent = '';
            this.generateImageAI = false;
            this.loadPosts();
        } catch (error) {
            console.error('Error creating post:', error);
            alert('Errore: ' + (error.response?.data?.message || error.message));
        } finally {
            this.isLoading = false;
        }
    },
    
    getImageUrl(img) {
      if (!img) return '';
      if (img.startsWith('http')) return img;
      let apiBase = (this.store.path || 'http://localhost:5000/login/').replace('/login/', '');
      if (apiBase.endsWith('/')) apiBase = apiBase.slice(0, -1);
      const cleanImg = img.startsWith('/') ? img : `/${img}`;
      return `${apiBase}${cleanImg}`;
    },
    
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    
    getStatusBadgeClass(status) {
      const classes = {
        'DRAFT': 'bg-light text-dark border',
        'PENDING_AGENT': 'bg-warning-soft text-warning',
        'SCHEDULED': 'bg-info-soft text-info',
        'PUBLISHED': 'bg-success-soft text-success',
        'FAILED': 'bg-danger-soft text-danger',
        'AGENT_ERROR': 'bg-danger-soft text-danger'
      };
      return classes[status] || 'bg-secondary';
    },
    
    getStatusLabel(status) {
      const labels = {
        'DRAFT': 'Bozza',
        'PENDING_AGENT': 'In elaborazione',
        'SCHEDULED': 'Programmato',
        'PUBLISHED': 'Pubblicato',
        'FAILED': 'Errore',
        'AGENT_ERROR': 'Errore AI'
      };
      return labels[status] || status;
    },

    getTypeBadgeClass(post) {
      const type = post.agentSettings?.contentType || 'manual';
      const classes = {
        'promotional': 'bg-primary-soft text-primary',
        'engagement': 'bg-purple-soft text-purple',
        'informative': 'bg-teal-soft text-teal',
        'mixed': 'bg-indigo-soft text-indigo',
        'manual': 'bg-gray-soft text-muted'
      };
      return classes[type] || classes.manual;
    },

    getContentTypeLabel(post) {
      const type = post.agentSettings?.contentType;
      if (!type) return 'Manuale';
      const labels = {
        'promotional': 'Promozionale',
        'engagement': 'Engagement',
        'informative': 'Informativo',
        'mixed': 'Misto'
      };
      return labels[type] || 'Social Post';
    },
    
    async publishToFacebook(post) {
      if (this.publishingPostId) return;
      this.publishingPostId = post._id;
      
      try {
        const apiBase = this.store.path || 'http://localhost:5000/login/';
        const endpoint = apiBase.endsWith('/') ? `${apiBase}social/posts/publish` : `${apiBase}/social/posts/publish`;
        
        await this.axios.post(endpoint, {
          postId: post._id,
          userId: this.userId
        }, {
          headers: {
            authorization: `Bearer ${localStorage.token ? JSON.parse(localStorage.token) : ''}`
          }
        });
        
        this.loadPosts();
      } catch (error) {
        console.error('Error publishing post:', error);
        alert('Errore: ' + (error.response?.data?.message || error.message));
        this.loadPosts();
      } finally {
        this.publishingPostId = null;
      }
    }
  }
}
</script>

<style scoped>
.social-posts {
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

/* Glassmorphism Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 1.25rem;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,0.05);
}

.icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
}

/* Soft Colors for Badges & Backgrounds */
.bg-primary-soft { background-color: rgba(13, 110, 253, 0.1); }
.bg-secondary-soft { background-color: rgba(108, 117, 125, 0.1); }
.bg-success-soft { background-color: rgba(25, 135, 84, 0.1); }
.bg-warning-soft { background-color: rgba(255, 193, 7, 0.1); }
.bg-info-soft { background-color: rgba(13, 202, 240, 0.1); }
.bg-danger-soft { background-color: rgba(220, 53, 69, 0.1); }
.bg-purple-soft { background-color: rgba(111, 66, 193, 0.1); }
.bg-teal-soft { background-color: rgba(32, 201, 151, 0.1); }
.bg-indigo-soft { background-color: rgba(102, 16, 242, 0.1); }
.bg-gray-soft { background-color: rgba(33, 37, 41, 0.05); }
.bg-light-soft { background-color: rgba(248, 249, 250, 0.8); }

.text-purple { color: #6f42c1; }
.text-teal { color: #20c997; }
.text-indigo { color: #6610f2; }
.text-primary-cool { color: #3a7bd5; }

/* Post Cards */
.post-card {
  background: #fff;
  border: 1px solid rgba(0,0,0,0.05);
  border-radius: 1rem;
  padding: 1.5rem;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  display: flex;
  flex-direction: column;
}

.post-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px -10px rgba(0,0,0,0.1);
  border-color: #3a7bd5;
}

.post-card.is-published {
  background-color: #fafffc;
  border-left: 4px solid #198754;
}

.post-content {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #2c3e50;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Timeline/Header */
.month-title {
  position: relative;
  display: flex;
  align-items: center;
  color: #2c3e50;
  font-weight: 700;
  text-transform: capitalize;
}

.title-line {
  flex-grow: 1;
  height: 2px;
  background: linear-gradient(to right, rgba(0,0,0,0.1), transparent);
  margin-left: 1rem;
}

/* Controls */
.search-bar {
  position: relative;
  width: 250px;
}

.search-bar i {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  font-size: 0.8rem;
}

.search-bar input {
  padding-left: 30px;
  border-radius: 20px;
  border: 1px solid rgba(0,0,0,0.1);
  font-size: 0.85rem;
}

.status-filter {
  width: 150px;
  border-radius: 20px;
  font-size: 0.85rem;
  border: 1px solid rgba(0,0,0,0.1);
}

.btn-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

@media (max-width: 991px) {
  .config-sidebar {
    position: static !important;
  }
}
</style>

